import styled from 'styled-components';
import { INPUTS, WRONG_LIGHT } from '@etiquette-ui/colors';
import RowContainer from 'components/Table/RowContainer';

const RowError = styled(RowContainer)`
    background-color: ${({item, count})=> item.price===item.posPrice ?  (count%2===0 ? `${INPUTS}` : 'transparent') : `${WRONG_LIGHT}`};
`;

export default RowError;